import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  root: {
    height: "100%",
    position: "relative",
    minHeight: 0,
    overflowY: "auto",
    marginTop: "unset",
    marginBottom: "unset",
    [theme.breakpoints.down("xs")]: {
      overflowY: "auto",
    },
  },
  gridItem: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    flexGrow: 1,
    // overflowY: "auto",
    overflowY: "hidden",
    minHeight: 0,
    [theme.breakpoints.down("xs")]: {
      overflowY: "hidden",
      height: "auto",
    },
  },
  headerText: {
    textAlign: "left",
  },
  subtitleText: {
    textAlign: "left",
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  contentBox: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    marginTop: theme.spacing(1.5),
  },
}))

export default styles
